module.exports = __webpack_public_path__ + "static/media/greenhouse2Step3-3.d8802f72.jpg";